export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-1200-fc2d1d5672b8c101df04b8c9136b155d.png";